import RequestAbstract from './abstract';

export default class Auth extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
    }

    updateLocalStorageToken(result) {
        localStorage.token = result.session;
        localStorage.role = result.user?.role?.name;
        localStorage.systemRole = result.user?.role?.systemRole;
    }

    async loginUser(username, password) {
        let result = await this.postForm('process-login', {
            username,
            password
        });
        if (result.error && result.error !== 'OK') {
            this.data.setLoggedIn(false);
            return result;
        }
        this.data.setLoggedIn(true);
        this.updateLocalStorageToken(result);

        return result;
    }

    async logoutUser() {
        this.data.updatePermissions({});
        this.data.setLoggedIn(false);
        return this.get('logout').then((result) => {
            localStorage.clear();
            return result;
        });
    }
}
